<script>
import TablePage from '@/found/components/table_page';
import Modal from '@/found/components/modal';
import { Form } from '@/found/views/mdm/views/terminal_info/form';
import DetailForm from '../form/detail.vue';

export default {
  extends: TablePage,
  name: 'main_list',
  components: {
    Modal,
    DetailForm,
    Form,
  },
  data() {
    return {
      // requestType: 'GET',
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    setColumn(v) {
      const item = v;
      if (item.field === 'grades') {
        item.search = 'true';
        item.title = '凤香档级';
        item.type = 'select';
        item.apiUrl = '/cps/fxh/terminalConfigurationRuleController/findSelect';
        item.multiple = true;
        item.optionsKey = {
          label: 'detailName',
          value: 'detailName',
        };
        item.isSearch = true;
        item.paramsName = 'detailName';
      }
      return item;
    },
    cellClick({ row, column }) {
      if (column.property === 'terminalCode') {
        this.formName = 'Form';
        this.formConfig = {
          ...row,
          type: 'fengxianghui',
        };
        this.formConfig.code = 'view';
        this.modalConfig.title = '终端信息';
        this.openFull();
      }
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      if (['history_records'].includes(val.code)) {
        this.formConfig = {};
        this.formName = 'Form';
        if (val.code === 'history_records') {
          this.modalConfig.title = '历史记录';
          this.formName = 'DetailForm';
        }
        this.modalConfig.width = '70%';
        this.modalConfig.height = '600px';
        this.formConfig = {
          type: val.code,
          id: row.id || '',
          code: val.code || '',
          scoreId: row.id || '',
        };
        this.openFull();
      }
    },
  },
};
</script>
